export const BASE_URL = "https://nf-api.onrender.com/api/v1/social/";
